import {
  DEFAULT_GRID_COLUMNS,
  DEFAULT_GRID_ROWS,
} from '../../components/PageConfigProvider/constants';
import type { TabContent } from '../../components/PageConfigProvider/page-reducer';
import {
  type Page,
  PageType,
  RevelioPageId,
} from '../../components/PageConfigProvider/types';
import type { MetricValues } from '../../components/PageConfigProvider/types/metric';
import { FilterId } from '../../filters/types/filters';

const activityPostingsMetrics: MetricValues[] = [
  'postings_active',
  'postings_new',
  'postings_removed',
];

const activityPostingsItems: TabContent['items'] = [
  {
    position: { x: 0, width: 16, y: 0, height: 12 },
    id: 'activity-postings-posting-salary',
    title: 'Salary',
    info: {
      text: 'The average salary listed on job postings.',
    },
    plot: {
      defaultMetricOptions: ['posting_salary'],
      chartType: 'line',
    },
  },
  {
    position: { x: 16, width: 16, y: 0, height: 12 },
    id: 'activity-postings-time-to-fill',
    title: 'Time to Fill',
    info: {
      text: 'The average time it takes to fill a job posting.',
    },
    plot: {
      defaultMetricOptions: ['time_to_fill'],
      chartType: 'line',
    },
  },
  {
    position: { x: 0, width: 32, y: 12, height: 24 },
    id: 'activity-postings-postings-volume',
    title: 'Postings',
    info: {
      text: 'The number of active job postings, new job postings, and removed job postings.',
    },
    plot: {
      defaultMetricOptions: activityPostingsMetrics,
      chartType: 'volume',
    },
  },
  {
    position: { x: 32, width: 16, y: 0, height: 36 },
    id: 'activity-postings-active-postings-company',
    title: 'Top Companies',
    info: {
      text: 'The top 15 companies in terms of number of added postings over the selected time range.',
    },
    plot: {
      defaultMetricOptions: ['postings_active'],
      secondaryDimension: 'company',
      chartType: 'grouped-bar',
    },
  },
];

const activityPostingsTab: TabContent = {
  id: 'activity-postings',
  items: activityPostingsItems,
  grid: { rows: DEFAULT_GRID_ROWS, columns: DEFAULT_GRID_COLUMNS },
  primaryFilter: {
    id: FilterId.ACTIVITY,
    tagColors: true,
  },
  secondaryFilters: [
    FilterId.GEOGRAPHY,
    FilterId.SENIORITY,
    FilterId.ROLE,
    FilterId.CUSTOM_SKILL,
    FilterId.INDUSTRY,
    FilterId.DATE_RANGE,
    FilterId.TITLE,
    FilterId.POSTINGS_SOURCE,
    FilterId.METRIC_MODE,
  ].map((id) => ({ id })),
};

export const activityPostings: Page = {
  type: PageType.REVELIO_PUBLIC,
  id: RevelioPageId.ACTIVITY_POSTINGS,
  revelioPageId: RevelioPageId.ACTIVITY_POSTINGS,
  name: 'Demand',
  owner: { id: 'revelio-labs', username: 'revelio-labs' },
  tabs: [
    {
      id: 'activity-postings',
      label: 'Demand',
      tabContent: activityPostingsTab,
      isActive: true,
    },
  ],
};
